module.exports = __webpack_public_path__ + "static/media/straighten_09.a2183bec.png";